<template>
  <div>
    <b-field label="Wortmuster zur Suche im Wörterbuch">
      <b-input v-model="pattern"></b-input>
    </b-field>
    <template v-if="pattern !== ''">
      <b-message v-if="pattern.length < 3" type="is-warning">
        Muster muss mindestens 3 Zeichen haben.
      </b-message>
      <b-message v-else-if="!patternIsValid" type="is-danger">
        <p><strong>Ungültiges Muster.</strong> Dein Muster muss mit aufsteigenden Ziffern beginnen und darf keine Ziffer überspringen.</p>
        <p>Beispiel: „HALLO“ hat das Muster „01223“. Das Muster „01224“ wäre nicht gültig, weil die 3 übersprungen wird.</p>
      </b-message>
    <b-message v-if="patternIsValid && matchingWords.length > limit" type="is-warning">
      Zuviele Treffer! Es werden nur die ersten {{ limit }} Treffer angezeigt.
    </b-message>
    <b-message v-else-if="patternIsValid" type="is-info">{{ matchingWords.length }} Treffer!</b-message>
    <ul v-if="patternIsValid && matchingWords.length > 0">
      <li v-for="match in matchingWords.slice(0, limit)" :key="match.word">
        {{ match.word.substr(0, match.start) }}<span class="highlight">{{ match.word.substring(match.start, match.end) }}</span>{{ match.word.substr(match.end) }}
      </li>
    </ul>
    </template>
  </div>
</template>

<script>
const wordlist = require('./wordlist.json');
export default {
  data () {
    return {
      pattern: '',
      wordlist: wordlist,
      limit: 100
    }
  },
  computed: {
    patternIsValid() {
      return validatePattern(this.pattern)
    },
    matchingWords() {
      if (this.pattern == '') {
        return [];
      }
      let result = [];
      let patternFn = compilePattern(this.pattern.toUpperCase())
      this.wordlist.forEach(function(word) {
        let match = patternFn(word)
        if (match !== false) {
          result.push(match)
        }
      })
      return result
    }
  }
}

function validatePattern(pattern) {
  if (pattern.length < 3) {
    return false;
  }
  let alphabet = "0123456789abcdefghijklmnopqrstuvwxyz"
  let indexPos = 0
  for (let i = 0; i < pattern.length; i++) {
    let pos = alphabet.indexOf(pattern[i])
    if (pos == -1 || pos > indexPos + 1) {
      return false
    }
    if (pos > indexPos) {
      indexPos = pos
    }
  }
  return true
}

function compilePattern(pattern) {
  let fragments = [];
  for (let i = 0; i < pattern.length; i++) {
    for (let j = 0; j < pattern.length; j++) {
      if (i == j) {
        continue
      }
      if (pattern[i] == pattern[j]) {
        fragments.push('word[' + i + ' + k] === word[' + j + ' + k]')
      } else {
        fragments.push('word[' + i + ' + k] !== word[' + j + ' + k]')
      }
    }
  }
  if (fragments.length == 0) {
    fragments.push('true')
  }
  let code = '(function(word) {\n';
  code += '  let plen = ' + pattern.length + ';\n';
  code += '  if (word.length < plen) { return false; }\n';
  code += '  for (let k = 0; k < 32; k++) {\n';
  code += '    if (plen + k > word.length) { return false; }\n'
  code += '    if (' + fragments.join(' && ') + ') {\n';
  code += '      return {"start": k, "end": k + plen, "word": word};\n';
  code += '    }\n';
  code += '  }\n';
  code += '  return false;\n';
  code += '})';
  return eval(code)
}
</script>
